import { HESTIA_MARKETING_FEATURE_FLAG } from '@/features/marketing/featureFlags'
import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const LEGACY_MARKETING_ROUTES = {
  'brand.apps.marketing.campaigns': 'brand.marketing.automations',
  'brand.apps.marketing.coupons': 'brand.coupon',
  'brand.apps.marketing.custom': 'brand.marketing.otc',
  'brand.apps.marketing.lifecycle': 'brand.marketing.lifecycle',
  'brand.apps.marketing.overview': 'brand.marketing.overview',
} as const

export const checkHestiaMarketingFeatureFlag: HermesGuardFn = async (to) => {
  if (typeof to.name !== 'string' || !(to.name in LEGACY_MARKETING_ROUTES)) {
    return undefined
  }

  const featureFlags = useFeatureFlags()
  if (featureFlags.isEnabled(HESTIA_MARKETING_FEATURE_FLAG)) {
    return undefined
  }

  return {
    name: LEGACY_MARKETING_ROUTES[
      to.name as keyof typeof LEGACY_MARKETING_ROUTES
    ],
    params: { brandId: to.params.brandId },
  }
}
